import React, { useEffect, useState, useContext } from 'react';
import { Grid, Box, Button, TextField } from "@material-ui/core";
import useStyles from "../../../themes/makeStyles";
import clsx from "clsx";
import { useForm, Controller } from "react-hook-form";
import moment from "moment";
import FormValidationErrorMessage from "../../../components/FormValidationErrorMessage";
import DateRangePicker from "../../../components/DateRangePicker";
import Autocomplete from "../../../components/AutoComplete";
import { default as ApiServices } from "../../../common";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { default as Apiservices } from '../../../common';
import GlobalContext from "../../../common/contexts/GlobalContext";
import TextFieldController from '../../../components/TextField';
import AutocompleteController from '../../../components/AutoComplete';

export default function FilterForm(props) {
    const classes = useStyles();
    const [sftorrStartDate, setSftorrStartDate] = useState('');
    const [sftorrEndDate, setSftorrEndDate] = useState('');
    const [unloadingStartDate, setUnloadingStartDate] = useState('');
    const [unloadingEndDate, setUnloadingEndDate] = useState('');
    const defaultValues = {
        customer_name:'',
        rake_name: '',
        origin: '',
        destination: '',
        rr_start_end_date: [],
        unloading_date: '',
    }
    const methods = useForm({
        mode: "onChange",
        validateCriteriaMode: "all",
        submitFocusError: true,
        defaultValues,
    });

    const [rakelistDropdownOpt, setRakelistDropdownOpt] = React.useState([]);
    const [customerNameDropdownOpt, setCustomerNameDropdownOpt] = React.useState([]);
    const [contractNumberDropdownOpt, setContractNumberDropdownOpt] = React.useState([]);

    const [disableDownloadButton, setDisableDownloadButton] = React.useState(false);
    const [resetvalues, setResetvalues] = React.useState(true);
    const {
        control, errors, handleSubmit, reset
    } = methods;

    const setMasterDropdownOptions = async () => {

        let listSftoActiveRakes = [];
        const listSftoRakes = await Apiservices.listSftoActiveRakes()
        console.log(listSftoRakes,"list")

        listSftoRakes.map((rakeSftoObj) => {
            let listSftoRakeObj = {};
            listSftoRakeObj.value = rakeSftoObj.rake_id;
            listSftoRakeObj.label = rakeSftoObj.rake_name; 
            listSftoActiveRakes.push(listSftoRakeObj);
        });
        setRakelistDropdownOpt(listSftoActiveRakes);
            let queryparams = {
                action_type: 'customer_name'
            };
        let listSftoActiveCustomer = [];
        const listSftoCustomers = await Apiservices.listCommonDropdownValues(queryparams)
        listSftoCustomers.records.map((obj) => {
            let listSftoCustomerObj = {};
            listSftoCustomerObj.value = obj.customer_name;
            listSftoCustomerObj.label = obj.customer_name; 
            listSftoActiveCustomer.push(listSftoCustomerObj);
        });
        setCustomerNameDropdownOpt(listSftoActiveCustomer);
        let listSftoActiveContracts = [];
        const listContracts = await Apiservices.getContractNoList()
        console.log(listContracts,"list")
        listContracts.map((obj) => {
            let listContractNoObj = {};
            listContractNoObj.value = obj.contract_no;
            listContractNoObj.label = obj.contract_no; 
            listSftoActiveContracts.push(listContractNoObj);
        });
        setContractNumberDropdownOpt(listSftoActiveContracts);

    };



    const onSubmitForm = async (data) => {
        console.log(Object.values(data), Object.values(data).some(val => !(val === null || val === '' || val === undefined)), "values")
        if (Object.values(data) && Object.values(data).length > 0 && Object.values(data).some(val => !(val === null || val === '' || val === undefined))) {
            const body = {
                customer_name: data.customer_name ? data.customer_name.label : null,
                rake_name: data.rake_name ? data.rake_name.label : null,
                contract_no: data.contract_no ? data.contract_no.value : null,
                rr_start_date: sftorrStartDate,
                rr_end_date: sftorrEndDate,
            }
            console.log('body comes here', body);
            props.getFilterData(body)
            setDisableDownloadButton(false)
        } else {
            return;
        }

    }

    const generateReport = async () => {
        let data = methods.getValues({ nest: true })
        const body = {
            customer_name: data.customer_name ? data.customer_name.label : null,
            rake_name: data.rake_name ? data.rake_name.label : null,
            contract_no: data.contract_no ? data.contract_no.value : null,
            rr_start_date: sftorrStartDate,
            rr_end_date: sftorrEndDate,
        }
        Apiservices.downloadSftoJobDetailsReports(body);
        setDisableDownloadButton(true)
    };

    const resetForm = () => {
        setResetvalues(!resetvalues)
        setSftorrStartDate(null);
        setSftorrEndDate(null);
        methods.reset(defaultValues);
        methods.setValue("rr_start_end_date", '');
        // methods.setValue("unloading_date", null)
        props.handleClear();
        setDisableDownloadButton(false);
    }

    useEffect(() => {
        const fetchData = async () => {
            await setMasterDropdownOptions()
        };
        fetchData();
    }, []);


    return (
        <>
            <form noValidate id="filter-form" onSubmit={handleSubmit(onSubmitForm)} key={resetvalues} >
                <Grid container spacing={2}>
                    <Grid item container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="customer_name"
                                id="customer_name"
                                control={control}
                                Values={customerNameDropdownOpt}
                                rules={{ required: false }}
                                required={false}
                                label="Customer Name"
                                error={errors.customer_name}
                            />
                            {errors.customer_name && (
                                <FormValidationErrorMessage
                                    errors={errors}
                                    errorMessagePrefix="Customer Name"
                                    name="customer_name"
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="rake_name"
                                id="rake_name"
                                control={control}
                                Values={rakelistDropdownOpt}
                                rules={{ required: false }}
                                required={false}
                                label="Rake Name"
                                error={errors.rake_name}
                            />
                            {errors.rake_name && (
                                <FormValidationErrorMessage
                                    errors={errors}
                                    errorMessagePrefix="Rake Name"
                                    name="rake_name"
                                />
                            )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <Autocomplete
                                name="contract_no"
                                id="contract_no"
                                control={control}
                                Values={contractNumberDropdownOpt}
                                rules={{ required: false }}
                                required={false}
                                label="Contract Number"
                                error={errors.contract_no}
                            />
                            {errors.contract_no && (
                                <FormValidationErrorMessage
                                    errors={errors}
                                    errorMessagePrefix="Contract Number"
                                    name="contract_no"
                                />
                            )}
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <Controller
                                as={<DateRangePicker />}
                                name="rr_start_end_date"
                                id="rr_start_end_date"
                                control={control}
                                rules={{ required: false }}
                                required={false}
                                disabled={false}
                                onChange={([value]) => {
                                    console.log(value, "date")
                                    let queryparams = {};
                                    let rr_start_end_dates = value.split("To");
                                    setSftorrStartDate(rr_start_end_dates
                                        ? moment(rr_start_end_dates[0].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                        : null);
                                    setSftorrEndDate(
                                        rr_start_end_dates
                                            ? moment(rr_start_end_dates[1].trim(), "DD-MM-YYYY").format("YYYY-MM-DD")
                                            : null
                                    );
                                    return value;
                                }}
                                label="RR Date Range"
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Box py={2}>
                    <Grid container direction="row" justify="space-between">
                        <Grid item>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={1} justify="flex-end">
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={clsx(
                                            classes.subTextButton
                                        )}
                                        type="button"
                                        onClick={generateReport}
                                        startIcon={<CloudDownloadIcon />}
                                        disabled={disableDownloadButton}
                                    >
                                        Export to Excel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        id="SearchIcon"
                                        className={classes.subTextButton}
                                        type="submit"
                                    // onClick={handleFilterSearch}
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        disabled={false}
                                        className={clsx(
                                            classes.subTextButton,
                                            "btnMinWidthSearch"
                                        )}
                                        onClick={resetForm}
                                    >
                                        Clear
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            </form>
        </>
    );
}